import { ModelBase } from 'store/model-base';

export class StatementSnapshot extends ModelBase {
    public static storeName: string = 'statementSnapshot';

    public id: Id;
    public type: string;
    public description: string;
    public amount: number;
    public isLegacy: boolean;
    public state: string;
    public subTitle: string;
    public title: string;
    public transactionDate: string;
}
